
export * from './product.type'
export * from './apiResponse'
export * from './common.type'
export * from './login.types'
export * from './cart.type'
export * from './coupon.type.'
export * from './address.type'
export * from './order.type'
export * from './voucher.type'
export * from './seo.type'
export * from './referral.type'
export * from './policypage.type'
export enum Iapi_version {
  V1 = "v1",
  V2 = "v2",
}

export interface IhomeContent {
  data:string;
}

export interface Ibanner {
  img_url:string;
  link_url: string | null;
  mobile_img_url:string;
  mobile_link_url:string;
}

export interface IhomeBanner {
  data: Ibanner[];
}

export interface Ifaq{
  faq_id:number;
  question:string;
  answer:string;
}

export interface IfaqGroup {
  Environment?: Ifaq[],
  Pickup?:Ifaq[];
  Order?:Ifaq[];
}

export interface IfaqApiResponse {
  data:IfaqGroup
}

export interface Iappliance {
  name: string;
  slug: string;
  image: string;
  price: number;
}

export interface Iappliances {
  appliances: Iappliance[];
}

export interface IapiResponse_appliances {
  data:Iappliances;
}

export interface IcontactUs {
  block_id:number;
  code:string;
  title:string;
  html_content:string;
  is_active:boolean;
}

export interface IapiResponse_contact_us{
 data:IcontactUs[]
}

export interface ImediaLogo {
  logo_img:string;
}

export interface IapiResponse_media_logo {
  status:boolean;
  result:ImediaLogo[]
}

export interface IBlogCategoryRelation {
  category_id: number;
  category_code: string;
  category_slug: string;
  category_title: string;
  category_description: string;
}

export interface Iblog {
  post_id: number;
  post_title: string;
  post_slug: string;
  post_tags: string | null;
  post_content?: string | null;
  primary_banner: string | null;
  thumbnail_banner: string | null;
  post_status: number;
  post_type: number;
  meta_title: string | null;
  meta_description: string | null;
  post_summary: string;
  meta_keyword: string | null;
  publish_date: string;
  created_at: string;
  created_by: string | null;
  updated_at: string;
  updated_by: string | null;
  category_relation: IBlogCategoryRelation[];
}

export interface Iblogs {
  currentPage: number;
  totalPages: number;
  perPage: number;
  totalItems: number;
  data: Iblog[]
}

export interface IapiResponse_blog_list {
  data:Iblogs 
}

export interface IapiResponse_blog_post_category {
  data:IBlogCategoryRelation[]
}

export interface IblogDetail {
  post_detail: Iblog
  relevant_blogs:Iblog[]
}

export interface IapiResponse_blog_post_detail {
  data: IblogDetail;
}


export interface IapiResponse_session {
  data: {
    message:string
  }
}

export interface IseoMetaDetails {
  data:{
status:boolean;
result:{
  code:string;
  page_title:string;
  meta_tag:string;
  meta_description:string;
  cronical_url:string;
}
  }

}




